import { API_BASE_URL, ApiError, apiGet, apiPostFormRaw, apiPut, getTenantId } from './client';
import type {
  ManualBalanceInput,
  ManualBalanceRow,
  ManualBalanceSaveResponse,
} from '../types/ManualBalance';

// Tenant-scoped (X-Tenant-Id applied by the client).
export function getManualBalances(): Promise<ManualBalanceRow[]> {
  return apiGet<ManualBalanceRow[]>('/api/manual-balances');
}

// REPLACES the whole list; valid rows go to the inventory (source 20).
export function saveManualBalances(rows: ManualBalanceInput[]): Promise<ManualBalanceSaveResponse> {
  return apiPut<{ rows: ManualBalanceInput[] }, ManualBalanceSaveResponse>('/api/manual-balances', { rows });
}

// Uploads the daily Excel; same replace-all semantics. 400 bodies carry a Hebrew message.
export async function importManualBalances(file: File): Promise<ManualBalanceSaveResponse> {
  const form = new FormData();
  form.append('file', file);
  const path = '/api/manual-balances/import';
  const res = await apiPostFormRaw(path, form);
  if (!res.ok) {
    const text = await res.text();
    let msg: string | null = null;
    try {
      const j = JSON.parse(text) as { message?: string; error?: string; detail?: string; title?: string };
      msg = j.message ?? j.error ?? j.detail ?? j.title ?? null;
    } catch {
      msg = text || null;
    }
    throw new ApiError(`POST ${path} failed: ${msg ?? res.status}`, 'POST', path, res.status, res.statusText, msg, text);
  }
  return (await res.json()) as ManualBalanceSaveResponse;
}

// Sample import file: fetched as a blob (needs credentials + the tenant header) and saved.
export async function downloadManualBalancesSample(): Promise<void> {
  const path = '/api/manual-balances/sample';
  const headers: Record<string, string> = {};
  const tenantId = getTenantId();
  if (tenantId !== null) headers['X-Tenant-Id'] = String(tenantId);
  const res = await fetch(`${API_BASE_URL}${path}`, { credentials: 'include', headers });
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = 'manual-balances-sample.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
